import React from "react";
import { PageHeader } from "./PageHeader";

export const HonoraryCommittee = props => {
  var ulSize = {
    fontSize: '18px'
  };
  return (
    <React.Fragment>
      <PageHeader title="Komitety" />
      <div className="content-wrapper">
        <div className="main-content program">
          <h2>Komitet Honorowy</h2>
          <ul style={ulSize}>
            <li>Prof. dr hab. Leszek Sirko, Instytut Fizyki PAN, Warszawa - <i>Przewodniczący Komitetu Honorowego</i></li>
            <li>Prof. dr hab. Andrzej Białas, Instytut Fizyki, Uniwersytet Jagielloński, Kraków</li>
            <li>Prof. dr hab. Iwo Białynicki-Birula Centrum Fizyki Teoretycznej PAN, Warszawa</li>
            <li>Prof. dr hab. Katarzyna Chałasińska-Macukow, Wydział Fizyki, Uniwersytet Warszawski</li>
            <li>Prof. dr hab. Tomasz Dietl, „MagTop”, Instytut Fizyki PAN, Warszawa</li>
            <li>Ks. Prof. dr hab. Michał Heller, Uniwersytet Papieski Jana Pawła II w Krakowie</li>
            <li>Prof. dr hab. Ryszard Horodecki, Wydział Matematyki, Fizyki i Informatyki, Uniwersytet Gdański</li>
            <li>Prof. dr hab. Karol Kołodziej, Wydział Matematyki, Fizyki i Chemii, Uniwersytet Śląski, Katowice</li>
            <li>Prof. dr hab. Franciszek Krok, Przewodniczący Komitetu Fizyki PAN, Wydział Fizyki, Politechnika Warszawska </li>
            <li>Prof. dr hab. Roman Micnas, Instytut Fizyki, Uniwersytet im. Adama Mickiewicza, Poznań </li>
            <li>Prof. dr hab. Stefan Pokorski, Instytut Fizyki Teoretycznej, Uniwersytet Warszawski</li>
            <li>Prof. dr hab. Henryk Szymczak, Instytut Fizyki PAN, Warszawa</li>
            <li>Prof. dr hab. Andrzej Kajetan Wróblewski, Wydział Fizyki, Uniwersytet Warszawski</li>
            <li>Prof. dr hab. Dariusz Wasik, Dziekan Wydziału Fizyki, Uniwersytet Warszawski</li>
            <li>Prof. dr hab. Maciej Żylicz, Prezes Fundacji na rzecz Nauki Polskiej, Warszawa</li>
          </ul>
        </div>
      </div>
    </React.Fragment>
  );
};

HonoraryCommittee.propTypes = {};
